import { render, staticRenderFns } from "./email-templates.vue?vue&type=template&id=27c7bf5e&scoped=true"
import script from "./email-templates.vue?vue&type=script&lang=js"
export * from "./email-templates.vue?vue&type=script&lang=js"
import style0 from "./email-templates.vue?vue&type=style&index=0&id=27c7bf5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c7bf5e",
  null
  
)

export default component.exports